const language = true;
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
const store = new Vuex.Store({
    // 存储状态（变量）
    state: {
        userInfo: {}, //储存用户相关信息
        chatList: [], // 聊天信息
        configPc: {
            side_bar: false, // 侧边栏
            showModal: false, //留言 评价弹出层
            messageModal: false, // 留言 弹框
            evaluateModal: false, // 评价 弹框
        },
        configH5: {
            showModal: false, // 底部side
            showMenus: false, // 文件拍照等菜单
            showEmoji: false // 表情
        },
        initData: {}, // 基础配置
        customer: {}, // 当前人工客服
        configData: { //其他配置文件

        },
        scrollBottom: 0,
        agentTyping: false, // 输入联想
        loadStatus: false, //加载历史记录 下拉loadStart 加载loading 结束 false 没有记录了 end
        robotTips: [], //输入联想
        robotTipsEnable: true,
        channelGroup: [],
        showChannelGroup: false, // 显示分组
        showFormChat: false, // 显示分组
        enableEvaluate: true, // 成功发送了消息就能评价
        connectStatus: 'robot', //连接状态 默认是机器人，评价时候判断对机器人、客服评价
        enablePlayAudio: true, // 是否可以播放提示音
        lastMessage: null, //机器人或者人工 最后一条消息
        evaluateData: {},
        chatStatus: 1, //1 正在会话 0 结束
        visibility:true,//是否在当前页签
    },
    getters: {
        // 参数列表state指的是state数据
        getChatList(state) {
            return state.chatList;
        },
        getConfigPc(state) {
            return state.configPc;
        },
        getConfigH5(state) {
            return state.configH5;
        },
        getUserInfo(state) {
            return state.userInfo;
        },
        getInitData(state) {
            return state.initData;
        },
        getCustomer(state) {
            return state.customer;
        },
        getLastMessage(state) {
            return state.lastMessage;
        },
    },
    // 通常跟api接口打交道
    actions: {
        updateChatItemStatus({ commit, state }, data) {
            commit("updateChatItemStatus", data);
        },
        visibility({ commit, state }, data) {
            commit("updateVisibility", data);
        },
        deleteChatItemStatus({ commit, state }, data) {
            commit("deleteChatItemStatus", data);
        },
        updateChatItemTips({ commit, state }, data) {
            commit("updateChatItemTips", data);
        },
        setChatList({ commit, state }, data) {
            console.log(data);
            commit("setChatListAction", data);
        },

        updateMessageLast({ commit }, data) {
            commit("updateLastMessage", data)
        },
        setConfigPc({ commit }, data) {
            commit("setConfigPcAction", data)
        },
        setConfigH5({ commit }, data) {
            commit("setConfigH5Action", data)
        },
        setInitData({ commit }, data) {
            commit("setInitDataAction", data)
        },
        setUserInfo({ commit }, data) {
            commit("setUserInfoAction", data)
        },
        setCustomer({ commit }, data) {
            commit("setCustomerAction", data)
        },
        // 刷新后获取当前会话
        setInitList({ commit }, data) {
            commit("setInitListAction", data)
        },
        // 自动滚动到最底部
        setScrollBottom({ commit }, data) {
            commit("setScrollBottomAction")
        },
        // 正在输入
        setAgentTyping({ commit }, data) {
            commit("setAgentTyping", data)
        },
        setLoadingStatus({ commit }, data) {
            commit('setLoadingStatus', data)
        },
        setRobotTips({ commit }, data) {
            commit('setRobotTips', data)
        },
        setChannelGroup({ commit }, data) {
            commit('setChannelGroup', data)
        },
        setShowChannelGroup({ commit }, data) {
            commit('setShowChannelGroup', data)
        },
        setShowFormChat({ commit }, data) {
            commit('setShowFormChat', data)
        },
        // 能否评价
        setEnableEvaluate({ commit }, data) {
            commit('setEnableEvaluate', data)
        },
        // 当前 机器人还是人工
        setConnectStatus({ commit }, data) {
            commit('setConnectStatus', data)
        },
        setEnablePlayAudio({ commit }, data) {
            commit('setEnablePlayAudio', data)
        },
        setLastMessage({ commit }, data) {
            commit('setLastMessage', data)
        },
        setStatus({ commit }, data) {
            commit('setChatStatus', data)
        },
        setEvaluate({ commit }, data) {
            commit('setEvaluate', data)
        }
    },
    //更新某写状态以[{key:*,value:*)]的形式
    mutations: {
        //更新消息状态
        updateChatItemStatus(state, data) {
            state.chatList.forEach(msg => {
                if (msg.id === data.id) {
                    msg.status = data.status
                }
            })
        },
        // 测绘消息移除显示
        deleteChatItemStatus(state, data) {
            state.chatList.forEach(msg => {
                if (msg.id === data.msgId) {
                    msg.recallFlag = 1;
                }
            })
        },
        updateVisibility(state, data) {
            state.visibility = data;
        },
        // 敏感词更新消息内容 -- 红色标识
        updateChatItemTips(state, data) {
            state.chatList.forEach(msg => {
                if (msg.id === data.id) {
                    msg.msgContent = data.message
                }
            })
        },
        // 刷新后获取当前会话
        setInitListAction(state, data) {
            state.chatList = data;
        },

        // 推送新消息 或者历史会话
        setChatListAction(state, data) {
            if (Array.isArray(data)) {
                state.chatList = data.concat(state.chatList)
            } else {
                state.chatList.push(data)
            }
        },
        // 排队转人工修改最后一条信息
        updateLastMessage(state, data) {
            if (data.id) {
                // 更新排队人数
                state.chatList.forEach(item => {
                    if (item.id === data.id) {
                        item.msgContent = data.msgContent
                    }
                })
            } else {
                state.chatList[state.chatList.length - 1].msgContent = data
            }
        },
        // 更新pc配置信息
        setConfigPcAction(state, data) {
            if (Array.isArray(data)) {
                data.map(item => {
                    state.configPc[item.key] = item.value;
                })
            } else {
                state.configPc[data.key] = data.value
            }
        },
        setConfigH5Action(state, data) {
            if (Array.isArray(data)) {
                data.map(item => {
                    state.configH5[item.key] = item.value;
                })
            } else {
                state.configH5[data.key] = data.value
            }
        },
        // 初始化数据
        setInitDataAction(state, data) {
            state.initData = data;
        },
        //设置用户信息
        setUserInfoAction(state, data) {
            if (Array.isArray(data)) {
                data.map(item => {
                    state.userInfo[item.key] = item.value;
                })
            } else {
                state.userInfo = data
            }
        },
        //设置客服信息
        setCustomerAction(state, data) {
            state.customer = data;
        },
        // 自动滚动到底部
        setScrollBottomAction(state) {
            state.scrollBottom++
        },
        // 正在输入
        setAgentTyping(state, data) {
            state.agentTyping = data;
        },
        // 加载状态
        setLoadingStatus(state, data) {
            state.loadStatus = data;
        },
        // 输入联想列表
        setRobotTips(state, data) {
            state.robotTips = data
        },
        // 技能组
        setChannelGroup(state, data) {
            state.channelGroup = data;
        },
        // 是否显示
      setShowChannelGroup(state, data) {
            state.showChannelGroup = data;
        },
        setShowFormChat(state, data) {
            state.showFormChat = data;
        },
        setEnableEvaluate(state, data) {
            state.enableEvaluate = data;
        },
        setConnectStatus(state, data) {
            state.connectStatus = data;
        },
        setEnablePlayAudio(state, data) {
            state.enablePlayAudio = data
        },
        setLastMessage(state, data) {
            state.lastMessage = data
        },
        setEvaluate(state, data) {
            state.evaluateData = data
        },
        setChatStatus(state, data) {
            state.chatStatus = data
        },
    }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js